import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createUser,
  deleteUser,
  resetUserPassword,
  updateUser,
} from '../services/admin';
import { showSuccessNotification } from '../services/common';

export const useCreateUser = () => {
  const queryClient = useQueryClient();
  return useMutation(createUser, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['users']).then(() => {});
      queryClient.invalidateQueries(['totalUsers']).then(() => {});
      showSuccessNotification('User has been created successfully.');
    },
  });
};

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  return useMutation(updateUser, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['users']).then(() => {});
      queryClient.invalidateQueries(['permissionsByUser']).then(() => {});
      showSuccessNotification('User has been updated successfully.');
    },
  });
};

export const useResetUserPassword = () => {
  const queryClient = useQueryClient();
  return useMutation(resetUserPassword, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['users']).then(() => {});
      showSuccessNotification('User has been reset password successfully.');
    },
  });
};

export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteUser, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['users']).then(() => {});
      queryClient.invalidateQueries(['totalUsers']).then(() => {});
      showSuccessNotification('User has been deleted successfully.');
    },
  });
};
